import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

/** Prefix shared by the picker and Builder queries, so one invalidation refreshes both. */
export const shockwave_contents_root_key = ["shockwave-contents"];

/**
 * Shockwave contents for pickers: `available_shockwave_contents` applies the visibility rule
 * (attribute enabled AND public with public access, or created by the user). Builder pages read the
 * base table through `selectShockwaveContentsForBuilder` instead.
 */
async function getShockwaveContents() {
    const { data } = await supabaseClient.from("available_shockwave_contents").select("*").throwOnError();

    return (data ?? []).flatMap((row) =>
        row.shockwave_type != null && row.impulses != null && row.dose != null && row.unit != null
            ? [
                  {
                      shockwave_type: row.shockwave_type,
                      impulses: row.impulses,
                      dose: row.dose,
                      unit: row.unit,
                      is_public: row.is_public ?? false,
                      created_by: row.created_by,
                  },
              ]
            : []
    );
}

export const shockwave_contents_key = [...shockwave_contents_root_key, "available"];

export const shockwaveContentsQueryOptions = () => {
    return queryOptions({
        queryKey: shockwave_contents_key,
        queryFn: async () => getShockwaveContents(),
    });
};

export function useShockwaveContentsQuery() {
    return useQuery(shockwaveContentsQueryOptions());
}
